import _ from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { useReducer, useCallback, useMemo } from 'react';
import { withPerfMarker } from '@bingads-webui/performance-marker-react-wrapper';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { VerticalSeparatedLayout } from '@bingads-webui-react/steps';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { startActivity } from './shared/util';
import { GoalCreationWizardContext } from './goal-creation-wizard-context';
import { goalCreationWizardReducer } from './goal-creation-wizard-reducer';
import { getStyles } from './get-styles';
import { STEP_PATHS } from './step-paths';
import {
  GoalDetailsStep,
} from './steps/index';

const {
  StepsContextProvider,
  StepContainer,
  Step,
} = VerticalSeparatedLayout;

const GoalCreationRecommendationWizardUnstyled = (props) => {
  const {
    classes,
    permissions,
    serverContext,
    scope,
    goalData,
    wizardDefaultState,
    perfMarker,
    exportUpdatedGoalObject,
  } = props;

  const {
    CurrentAccount: {
      AdvertiserCustomerID: cid,
      Id: aid,
    },
  } = serverContext;

  const [state, dispatch] = useReducer(goalCreationWizardReducer, wizardDefaultState);
  const logActivity = useMemo(() => {
    const activity = state.logScenario[state.currentStep].create();
    startActivity(activity);
    return activity;
  }, [state.logScenario, state.currentStep]);

  const goToNext = useCallback(() => _.noop); // eslint-disable-line react-hooks/exhaustive-deps
  const goBack = useCallback(() => _.noop); // eslint-disable-line react-hooks/exhaustive-deps

  const wizardContext = useMemo(() => ({
    goToNext,
    goBack,
    dispatch,
    permissions,
    serverContext,
    isEditScenario: state.isEditScenario,
    goalData,
    goalContext: {
      ...state.goalObject, // overwrite read-from
    },
    logActivity,
    scope,
    cid,
    aid,
  }), [goToNext, goBack, permissions, serverContext, state.isEditScenario, state.goalObject, goalData, logActivity, scope, cid, aid]);

  const childPerfMarker = useMemo(() => perfMarker.createChild(state.currentStep), [state.currentStep, perfMarker]);

  return (
    <div className={classNames('goal-creation-wizard', 'goal-creation-page', classes.conversionWizard)}>
      <GoalCreationWizardContext.Provider value={wizardContext}>
        <StepsContextProvider currentPath={state.currentStep}>
          <div id="goal-creation-wizard-steps-content" className={classes.wizardContentContainer}>
            <StepContainer>
              <Step path={STEP_PATHS.goalDetails.normalGoal.id}>
                <GoalDetailsStep
                  perfMarker={childPerfMarker}
                  exportUpdatedGoalObject={exportUpdatedGoalObject}
                />
              </Step>
            </StepContainer>
          </div>
        </StepsContextProvider>
      </GoalCreationWizardContext.Provider>
    </div>
  );
};

GoalCreationRecommendationWizardUnstyled.propTypes = {
  classes: PropTypes.shape(_.mapObject(getStyles(), _.constant(PropTypes.string.isRequired)))
    .isRequired,
  permissions: PropTypes.shape({}).isRequired,
  serverContext: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({}),
  }).isRequired,
  goalData: PropTypes.shape({}).isRequired,
  wizardDefaultState: PropTypes.shape({}).isRequired,
  instrumentation: PropTypes.shape({}).isRequired,
  perfMarker: PropTypes.shape({
    done: PropTypes.func,
    willInit: PropTypes.func,
    willRender: PropTypes.func,
    createChild: PropTypes.func,
  }).isRequired,
  exportUpdatedGoalObject: PropTypes.func.isRequired,
};

export const GoalCreationRecommendationWizard = withPerfMarker(withInstrumentation(withDefaultStyles(GoalCreationRecommendationWizardUnstyled, getStyles)));
